import { render, staticRenderFns } from "./PoweredByLgame.vue?vue&type=template&id=cce89b88"
import script from "./PoweredByLgame.vue?vue&type=script&lang=js"
export * from "./PoweredByLgame.vue?vue&type=script&lang=js"
import style0 from "./PoweredByLgame.vue?vue&type=style&index=0&id=cce89b88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports